
var sprite = require("C:/Users/semi-opaque/Desktop/code/mudutv_web/mobile/assets/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 72 72\" id=\"dislike\" ><title>&#x54ED;&#x8138;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path fill=\"#FFF\" d=\"M47 22h2v6h-2zM23 22h2v6h-2z\"/><path d=\"M21 51s4.6-7 15-7 15 7 15 7\" stroke=\"#FFF\" stroke-width=\"2\"/></g></symbol>";
module.exports = sprite.add(image, "dislike");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/toast/style/assets/dislike.svg
// module id = 240
// module chunks = 0 1 2